import React, { useState, useEffect } from 'react';

const ExitIntentPopup = ({ onGetStarted }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    // Check if popup has already been shown in this session
    const shown = sessionStorage.getItem('exitIntentShown');
    if (shown) {
      setHasShown(true);
      return;
    }

    // Track mouse movement
    const handleMouseLeave = (e) => {
      // Only trigger if mouse is moving upward toward the top of the page
      if (e.clientY <= 0 && !hasShown && !showPopup) {
        setShowPopup(true);
        setHasShown(true);
        sessionStorage.setItem('exitIntentShown', 'true');
      }
    };

    // Add event listener
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown, showPopup]);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleGetStarted = () => {
    setShowPopup(false);
    if (onGetStarted) {
      onGetStarted();
    }
  };

  if (!showPopup) return null;

  return (
    <div 
      className="exit-intent-overlay"
      onClick={handleClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(5px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div 
        className="exit-intent-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '500px',
          width: '100%',
          position: 'relative',
          animation: 'slideIn 0.3s ease-out',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '24px',
          border: '1px solid rgba(255, 255, 255, 0.5)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            color: '#000000',
            cursor: 'pointer',
            padding: '0',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.1)'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          ×
        </button>

        <div className="text-center" style={{ padding: '2rem' }}>
          <div className="mb-3">
            <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '3rem', color: '#f59e0b' }}></i>
          </div>
          
          <h2 className="mb-3" style={{ fontSize: '1.75rem', fontWeight: '700', color: '#000000' }}>
            Wait! Don't Leave Yet
          </h2>
          
          <p className="mb-3" style={{ fontSize: '1.1rem', color: '#000000', lineHeight: '1.6' }}>
            <strong>Save Hundreds of Dollars</strong>
          </p>
          
          <p style={{ fontSize: '1rem', color: '#000000', lineHeight: '1.6', marginBottom: '1.5rem' }}>
            Funeral homes and crematoriums typically charge <strong>$200-$500</strong> or more to write an obituary. 
            With ObitAuthor, you can create professional obituaries for just <strong>$9.99</strong> — that's less than $2 per obituary.
          </p>

          <div className="alert alert-info mb-4" style={{ 
            background: 'rgba(30, 64, 175, 0.1)', 
            border: '1px solid rgba(30, 64, 175, 0.3)',
            color: '#1e40af',
            borderRadius: '12px',
            padding: '1rem',
            textAlign: 'left'
          }}>
            <strong>What You Get:</strong>
            <ul className="mb-0 mt-2" style={{ paddingLeft: '1.5rem' }}>
              <li>5 professional obituary generations</li>
              <li>AI-powered, personalized content</li>
              <li>Print-ready PDF downloads</li>
              <li>Use anytime — no expiration</li>
            </ul>
          </div>

          <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
            <button
              className="btn btn-primary btn-lg pulsate-btn"
              onClick={handleGetStarted}
              style={{ minWidth: '200px' }}
            >
              <i className="bi bi-check-circle-fill me-2"></i>
              Get Started Now
            </button>
            
            <button
              className="btn btn-outline-secondary btn-lg"
              onClick={handleClose}
              style={{ minWidth: '200px', color: '#000000', borderColor: '#000000' }}
            >
              No Thanks
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ExitIntentPopup;

